import { http } from '@/libs/util'
export default {
    data() {
        return {
            expand: false,
            item_loading: false,
            child_items: [],
        }
    },
  computed: {


  },
  created() {
    // eslint-disable-next-line
    this.getCardData(Util.api.query_customer_with_customer_account, 'staff_accounts')
    // eslint-disable-next-line
    this.getCardData(Util.api.query_payee_company_account, 'company_accounts')
    //
  },
  methods: {
    getCardData(api, type) {
        http.cacheGet(api).then((res) => {
          switch (type) {
          case 'staff_accounts':
            this.staff_accounts = res;
            break;
          case 'company_accounts':
            this.company_accounts = res.payee_companies;
            break;
          default:
            break;
          }
        })
      },
      toggleExpand() {
        this.expand = !this.expand
        if (!this.child_items.length) {
          this.item_loading = true
          http.get(this.get_items_api, {
            id: this.value.id
          }).then((res) => {
            this.child_items = res.items
          }).finally(() => {
            this.item_loading = false
          })
        }
      },
      edit() {
        this.$emit('edit', this.value)
      },
      copy() {
        this.$emit('copy', this.value)
      }
  },
}
